import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { authenticationService } from '../../services/auth.service';
import CongregationChart from '../congregation/congregation-chart/CongregationChart';
import MeetingChart from '../meeting-chart/MeetingChart';

import '../shared/card.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import toastOptions from '../../utils/toastOptions';
import MemberBirthdayList from '../member/member-birthday-list/MemberBirthdayList';
import CheckIn from '../check-in/CheckIn';

export default function DashboardMain() {
    const [activesMembers, setActivesMembers] = useState<number>();

    useEffect(()=> {        
        async function countMembers() {
            try {
                const { data } = await api.get('members/actives/count');

                setActivesMembers(+(data));                                
            } catch (ex) {
                toast.warning("Problemas ao verificar membros ativos", toastOptions);
            }
        }

        countMembers();
    }, []);

    return <>
        <div className="uk-section uk-section-muted uk-padding-small">
            <div className="uk-grid-small" uk-grid="true">
                <div className="uk-width-1-2@m">
                    {
                        !authenticationService.isRoutine() &&
                            <div>
                                <div className="uk-card uk-card-primary uk-card-small uk-card-hover">
                                    <div className="uk-card-header">
                                        <div className="uk-grid-small uk-flex-middle" uk-grid="true">
                                            <div className="uk-width-expand">
                                                <h3 className="uk-card-title uk-margin-remove-bottom">Membros Ativos</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="uk-card-body">
                                        {
                                            (activesMembers == undefined) ? 
                                                <div uk-spinner="true; ratio:2">Carregando...</div>
                                            :
                                                <h1 className="uk-heading-xlarge">{activesMembers}</h1>
                                        }
                                    </div>
                                    <div className="uk-card-footer">
                                        <Link to="/membros">Acessar Membros <span uk-icon="arrow-right"></span></Link>
                                    </div>
                                </div>
                            </div>
                    }
                    {authenticationService.hasMeetingModule() &&             
                        <div className="uk-margin-top">
                            <CheckIn />
                        </div>
                    }
                </div>  
                {!authenticationService.isRoutine() && (
                    <div className="uk-width-1-2@m">
                        <MemberBirthdayList />
                    </div>
                )}
            </div>
            {
                !authenticationService.isRoutine() && (
                    <div className="uk-grid-match uk-child-width-1-2@m uk-flex-center uk-text-center" uk-grid="true">
                        {authenticationService.hasMemberModule() && (
                            <div>
                                <CongregationChart type="member"/>              
                            </div>
                        )}
                        {authenticationService.hasMeetingModule() && (
                            <div>
                                <MeetingChart/>              
                            </div>
                        )}
                    </div>)
            }
        </div>
    </>
}